
import styled from 'styled-components';
import TextField from '@material-ui/core/TextField';
import Select from '@material-ui/core/Select';

export const ElementWrapper = styled.div`
display: flex;
padding-top: 8px; 
`;



export const Row = styled.div`
display: flex;

`;

export const SiteData = styled.div`
display: flex; 
margin-bottom: 8px;
color: black;  
`;

export const SiteNameLabel = styled.div`
font-size: 16px;
font-weight: 500; 
`;

export const CheckBoxRow = styled.div`
display: flex;
align-items: center;
justify-content: flex-start;
margin: 0 0 0 -10px;
`


export const BlueBtn = styled.button`
color: #fff;
background: #007ABA;
border: 2px solid #007ABA;

&:hover{
    background: #025681;
    border-color: #025681;
}
`

export const FooterContainer = styled.div`
display: flex;
align-items: center;
justify-content: flex-end;
padding: 20px 20px 20px 0;

button{
    outline: 0;
    // border: 0;
    padding: 8px 12px;
    font-size: 14px; 
    cursor: pointer;
    font-family: 'Roboto';
    transition: all 0.2s;
}

button + button{
    margin-left: 12px;
}
`

export const TransBtn = styled.button`
color: #3b3d46;
background: #fff;
border: 2px solid #3b3d46;
font-weight: 500;

&:hover{
    background: #e0dddd;
    border-color: #e0dddd;
}
`


export const StyledField = styled.div`
width: 220px;
display: flex;
`;

export const ModalHeader = styled.div`
display: flex;
flex-direction: row;
height: 50px;
font-size: 18px;
background-color: #007ABA;
color: white;
align-items: center;
padding: 0 24px;    
justify-content: center;
`

export const MainContent = styled.div`
margin-top: 0;
margin-bottom: 20px;
display: flex;
flex-direction: column;
align-items: center;
`;


export const PopupContainer = styled.div`
font-family: 'Roboto';
`
export const PopupHeader = styled.div`
display: flex;
align-items: center;
justify-content: flex-start;
font-size: 21px;
font-weight: 600;
padding: 10px 0 0 20px;
`
export const HeadDes = styled.div`
padding: 0 0 0 20px;
`
export const BodyContent = styled.div`
display: flex;
justify-content: center;
padding: 15px 20px 40px 20px;
height: calc(100vh - 340px);
overflow-y: auto;
form{
    width: 100%;
}
`
export const Formcontainer = styled.div`
display: flex;
align-items: flex-start;
justify-content: center;
flex-direction: column;
margin-bottom: 10px;
`

export const StyledTextField = styled(TextField)`
display: flex;
width: 100%;

input{
padding: 9px !important;

  &:focus{
    border-color:#2684FF !important;
}
}

& .MuiOutlinedInput-root {
  &.Mui-focused fieldset {
    border-color: #2684FF !important;
  }
}

`

export const LabelText = styled.label`
color: #4f4f4f;
font-size: 15px;
`

export const ErrorLine = styled.p`
font-size: 0.75rem;
margin-top: 3px;
text-align: left;
font-family: "Roboto", "Helvetica", "Arial", sans-serif;
font-weight: 400;
line-height: 1.66;
letter-spacing: 0.03333em;
margin-left: 5px;
color: #f44336; 
`


export const SelectField = styled(Select)`
display: flex;
//width: 100%;

input{
    padding: 9px !important;
   
        &:focus{
          border-color:#2684FF !important;
      } 
    }
  
    & .MuiOutlinedInput-input {
       padding: 5px;
      } 
`